import { useState, React, useContext } from "react";
import { AuthContext } from "../../context/AuthContext";
// import { signInWithEmailAndPassword } from "firebase/auth";
// import { auth } from "../../firebase";
import { Image, LoginContainer, LoginForm } from "./SignupStyles";
import farmer from "../../Assets/farmer.webp";
import { useNavigate, Link } from "react-router-dom";
import { useQuery } from "react-query";
import axios from "axios";

// fetch login data from backend

const SigupPage = () => {
  const navigate = useNavigate();
  const { currentUser, setUser } = useContext(AuthContext);

  const initialState = {
    name: "",
    username: "",
    email: "",
    password: "",
    passwordConfirm: "",
    bio: "",
    phoneNumber: "",
  };

  const fetchLogin = async (userInfo) => {
    console.log(userInfo);
    return axios.post(
      "https://ancient-caverns-61891.herokuapp.com/api/v1/users/signup",
      userInfo,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
  };

  const [user, setUserData] = useState(initialState);
  const { name, username, password, email, passwordConfirm, bio, phoneNumber } =
    user;

  const handleInput = (e) => {
    const value = e.target.value;
    const name = e.target.name;
    console.log(value);
    setUserData({
      ...user,
      [name]: value,
    });
    console.log("user", user);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { data } = await fetchLogin({
      email,
      name,
      username,
      password,
      passwordConfirm,
      bio,
      phoneNumber,
    });
    console.log("data", data);

    if (data.status === "success") {
      setUser({ currentUser: data.token });
      //   navigate("/dashboard");
    }
    console.log(currentUser);
  };

  return (
    <LoginContainer>
      <LoginForm
        onSubmit={(e) => {
          handleSubmit(e);
        }}
      >
        <h1>
          Welcome to <span>FarmHub</span>
        </h1>
        <label>Username</label>
        <input
          name="username"
          placeholder="Enter your username"
          value={username}
          onChange={handleInput}
        />
        <label>Name</label>
        <input
          name="name"
          placeholder="Enter your full name"
          value={name}
          onChange={handleInput}
        />
        <label>Email</label>
        <input
          name="email"
          placeholder="Enter your email"
          value={email}
          onChange={handleInput}
        />
        <label>Phone number</label>
        <input
          name="phoneNumber"
          placeholder="Enter your phone number"
          value={phoneNumber}
          onChange={handleInput}
        />
        <label>Password</label>
        <input
          name="password"
          placeholder="Enter your password"
          value={password}
          onChange={handleInput}
        />
        <label>Confirm password</label>
        <input
          name="passwordConfirm"
          placeholder="Enter your password"
          value={passwordConfirm}
          onChange={handleInput}
        />
        <label>Bio</label>
        <textarea
          name="bio"
          placeholder="Enter your bio"
          value={bio}
          onChange={handleInput}
          cols={10}
          rows={10}
        />
        <button onClick={handleSubmit}>Sign up</button>
        {/* {
          // if error is true, display error message
          error && <span>Something went wrong!</span>
        } */}
        <div>
          Already have an account?{" "}
          <Link to="/login">
            <span>Sign in</span>
          </Link>
        </div>
      </LoginForm>
      <Image></Image>
    </LoginContainer>
  );
};

export default SigupPage;
